import * as L from 'leaflet';

require('leaflet.zoomhome');

const Vector = require('esri-leaflet-vector');
require('leaflet.markercluster');

const Cluster = require('esri-leaflet-cluster');

import Pins from '../img/pins.png';
import Pin from '../img/pin.png';

export default function loadMap() {
    const map = L.map("map", {
        minZoom: 12,
        maxZoom: 19,
        zoomSnap: 0.5,
        zoomControl: false
    });

    Vector
        .vectorTileLayer(config.map.basemap.itemId,
            {
                "portalUrl": config.map.basemap.portalUrl
            })
        .addTo(map);

    let layer = Cluster
        .featureLayer({
            url: config.map.layers.poiUrl,
            where: config.map.layers.where,
            fetchAllFeatures: true,
            showCoverageOnHover: false,
            ignoreRenderer: true,
            spiderLegPolylineOptions: {
                weight: 3,
                color: '#000000',
                opacity: 1
            },
            spiderfyDistanceMultiplier: 2,
            iconCreateFunction: function (cluster: L.MarkerCluster) {
                return L.icon({
                    iconUrl: Pins,
                    iconSize: [40, 40],
                    iconAnchor: [20, 20]
                })
            },
            pointToLayer: function (geojson: L.Point, latlng: L.LatLngExpression) {
                return L.marker(latlng, {
                    icon: L.icon({
                        iconUrl: Pin,
                        iconSize: [35, 35],
                        iconAnchor: [17.5, 35],
                        popupAnchor: [0, -35]
                    })
                })
            }
        })
        .bindPopup(function (layer: any) {
            let template: string =
                "<b class='popup-title'>{lieu}</b>" +
                "<br/>" +
                "{public} : {activite}" +
                "<br/>" +
                "<br/>" +
                "<b class='popup-label'>Quand ?</b>{jour}, {heure}" +
                "<br/>" +
                "<b class='popup-label'>Où ?</b>{adresse}" +
                "<br/>" +
                "<span class='popup-label'></span>{npa}, {localite}" +
                "<br/>" +
                "<br/>" +
                "<b class='popup-label'>Lien</b><a href='{lien_web}' target='_blank'>Plus d'infos</a>";
            return L.Util.template(template, layer.feature.properties);
        })
        .addTo(map);

    layer
        .query()
        .bounds(function (error: any, latLngBounds: L.LatLngBounds, response: any) {
            if (error) {
                console.log(error);
                return;
            }
            map.fitBounds(latLngBounds);

            // @ts-ignore
            L.Control.zoomHome()
                .addTo(map)
                .setHomeBounds(latLngBounds);
        });
}